let bookingChunkPrefetched = false;

export const prefetchBookingChunk = (): void => {
  if (bookingChunkPrefetched) return;
  bookingChunkPrefetched = true;
  import("../../routes/bookingInProgress/BookingInProgress");
};
